import React         from 'react';
import PropTypes     from 'prop-types';
import classNames    from 'classnames';
import { CloseIcon } from '../';

import './alert.scss';


export default class Alert extends React.Component {
    static propTypes = {
        children: PropTypes.oneOfType( [
            PropTypes.arrayOf( PropTypes.node ),
            PropTypes.node
        ] ),
        onDismiss: PropTypes.func,
        type: PropTypes.string.isRequired,
        id: PropTypes.string
    };

    setFocus = ( node ) => {
         if ( node ) {
             node.setAttribute( 'tabindex', '-1' );
             node.style.outline = 'none';
             node.focus();
        }
    };

    render() {
        const {
            onDismiss,
            dismissLabel,
            children,
            type,
            id
        } = this.props;

        const dismissable = !!onDismiss;
        const classes = classNames( {
            'alert-panel': true,
            'dismissable': dismissable,
            'alert-success': type == 'success',
            'alert-error': type == 'error',
            'alert-warning': type == 'warning'
        } );

        let alertContent = children;

        if ( Array.isArray( children ) ) {
            alertContent = children.map( ( child, index ) => <div key={ index } dangerouslySetInnerHTML={ { __html: child.props.children } }/> );
        } else if( typeof children === 'object' ) {
            if ( typeof children.props.children === 'string' ) {
                alertContent = <div dangerouslySetInnerHTML={ { __html: children.props.children } }/>;
            }
        }

        return (
            <div role="alert" className={ classes } ref={ this.setFocus } id={ id }>
                { dismissable && <a href="#" className="close-btn" aria-label={ dismissLabel } onClick={ ( e ) => {
                    e.preventDefault();
                    if ( typeof onDismiss === 'function' ) {
                        onDismiss();
                    }
                } }><CloseIcon /></a> }
                { alertContent }
            </div>
        );
    }
}
